export default {
  presenters: [],
  presenter: undefined,
};
